import React from "react";

import { VariantType } from "@/styles/components/table/StyledTableCellText";
import {
    StyledFlexRow,
    StyledTableCell,
    StyledTableCellContainer,
    StyledTableCellItem,
    StyledTableCellText,
} from "@/styles/styled";

export type Line = {
    key: string | number;
    line1: string;
    line2: string;
};

export type MultiLinesCellProps = {
    variant1?: VariantType;
    variant2?: VariantType;
    highlight1: boolean;
    highlight2: boolean;
    testId: string;
    lines: Line[];
    icon?: React.ReactElement;
};

const MultiLinesCell = ({
    variant1 = "normal",
    variant2 = "normal",
    highlight1 = false,
    highlight2 = false,
    testId,
    lines,
    icon,
}: MultiLinesCellProps): React.ReactElement => {
    const rowsContent = (
        <>
            {lines.map((row) => (
                <StyledTableCellContainer key={row.key} style={{ overflow: icon ? "hidden" : "visible" }}>
                    <StyledTableCellItem $withEllipsis>
                        <StyledTableCellText $variant={variant1} $highlight={highlight1}>
                            {row.line1}
                        </StyledTableCellText>
                    </StyledTableCellItem>
                    <StyledTableCellItem $withEllipsis>
                        <StyledTableCellText $variant={variant2} $highlight={highlight2}>
                            {row.line2}
                        </StyledTableCellText>
                    </StyledTableCellItem>
                </StyledTableCellContainer>
            ))}
        </>
    );

    const innerContent = icon ? (
        <StyledFlexRow>
            {icon}
            {rowsContent}
        </StyledFlexRow>
    ) : (
        rowsContent
    );
    return (
        <StyledTableCell data-testid={testId} $noEllipsis>
            {innerContent}
        </StyledTableCell>
    );
};

export default MultiLinesCell;
